const config = {
  uploadGoodsImageUrl: 'https://webapi.repechageskincare.com.cn/admin/upload/goods/image',
  uploadGoodsSwiperImageUrl: 'https://webapi.repechageskincare.com.cn/admin/upload/goods/swiper_image',
  uploadGoodsVideoUrl: 'https://webapi.repechageskincare.com.cn/admin/upload/goods/video',
  uploadGoodsVideoCoverUrl: 'https://webapi.repechageskincare.com.cn/admin/upload/goods/video_cover',
  imageDisplayBaseUrl: 'https://webapi.repechageskincare.com.cn/storage/'
  // uploadGoodsImageUrl: 'http://repechage_api.idatamind.com/admin/upload/goods/image',
  // uploadGoodsSwiperImageUrl: 'http://repechage_api.idatamind.com/admin/upload/goods/swiper_image',
  // uploadGoodsVideoUrl: 'http://repechage_api.idatamind.com/admin/upload/goods/video',
  // uploadGoodsVideoCoverUrl: 'http://repechage_api.idatamind.com/admin/upload/goods/video_cover',
  // imageDisplayBaseUrl: 'http://repechage_api.idatamind.com/storage/'
}
export { config }
